import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {ResourceService} from '../../resource.service';
import {LayoutService} from '../../../layout/layout.service';
import {CacheService} from '../../../cache/cache.service';
import {MatDialog} from '@angular/material/dialog';
import {MatInput} from '@angular/material/input';
import {ViewTabComponent} from '../viewtab.component';
import {DialogsService} from '../../../shared/dialog/dialogs.service';
import {ErrorService} from '../../../error/error.service';
import {CtrlIdentitypickerSingleAbstract} from './ctrl-identitypicker-single.abstract';
import {EnvironmentConfigService} from '../../../core/services/environment-config.service';

@Component({
  selector: 'ctrl-identitypicker-single',
  template: `
    @if ((showAutocomplete() | async) != true) {
      <div class="viewMode">
        <p>
          @if (formControl.value) {
            <a (click)="resourceClick(formControl.value, $event)" class="resource">
              {{ displayName(formControl.value) | async }}</a
            >
          }
        </p>
        @if (getCaughtObservable(isEnabled) | async) {
          <button mat-icon-button (click)="onRemoveClick()" class="bt-resource-remove">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
    <div [hidden]="(showAutocomplete() | async) != true" class="select">
      <mat-form-field floatLabel="never">
        <input
          matInput
          [placeholder]="autocompletePlaceholder | async"
          [matAutocomplete]="auto"
          [formControl]="formControl"
        />
      </mat-form-field>

      <mat-autocomplete #auto="matAutocomplete">
        @for (res of filteredResources | async; track res) {
          <mat-option
            [matTooltip]="res.__tooltip_text | async"
            matTooltipClass="ctrl-idpickersingle-actooltip"
            [value]="formatValue(res[myEnv.Attributes.ObjectID])"
          >
            @if (res[myEnv.Attributes.DisplayName]) {
              <span>{{ res[myEnv.Attributes.DisplayName] }}</span>
            }
            @if (res[myEnv.Attributes.DisplayName] == null) {
              <span>{{ emptyDisplayNameLabel | async }}</span>
            }
          </mat-option>
        }
        @if (emptyResult) {
          <mat-option value="">
            <language
              key="CtrlIdentitypickerSingleNoItems"
              defaultValue="No items found."
            ></language>
          </mat-option>
        }
      </mat-autocomplete>
      @if (showBtOpen) {
        <div class="buttons">
          <button mat-raised-button color="primary" (click)="onOpenClick()">
            <mat-icon>open_in_new</mat-icon>
            <language key="CtrlIdentitypickerSingleOpen" defaultValue="Open"></language>
          </button>
        </div>
      }
    </div>
    @if ((getCaughtObservable(isEnabled) | async) && formControl.touched) {
      <div class="validationErrors">
        @if (formControl.hasError('pattern') || formControl.hasError('required')) {
          <mat-error>
            <language key="ControlErrorRequired" defaultValue="This field is required."></language>
          </mat-error>
        }
        @if (formControl.hasError('allowed-selection')) {
          <mat-error>{{ allowedSelectionErrorMessage }}</mat-error>
        }
      </div>
    }
  `,
  styleUrls: ['./ctrl-identitypicker-single.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlIdentitypickerSingleComponent
  extends CtrlIdentitypickerSingleAbstract
  implements OnDestroy
{
  @Input() objectDisplayName: string = null;
  constructor(
    parent: ViewTabComponent,
    dialog: MatDialog,
    dialogsService: DialogsService,
    resourceService: ResourceService,
    layoutService: LayoutService,
    cacheService: CacheService,
    changeDetector: ChangeDetectorRef,
    _ngZone: NgZone,
    errorService: ErrorService,
    envConfig: EnvironmentConfigService,
  ) {
    super(
      parent,
      dialog,
      dialogsService,
      resourceService,
      layoutService,
      cacheService,
      changeDetector,
      _ngZone,
      errorService,
      envConfig,
    );
  }

  @ViewChild(MatInput, {static: true}) inputField: MatInput;
}
